module.exports = __webpack_public_path__ + "catalog/items/stairs/straight-stairs/straight-stairs-icon.svg";